import { gql } from '@apollo/client'

export const CONFIRM_RESERVE_MUTATION = gql`
  mutation ConfirmReserve($input: ConfirmReserveInput!) {
    confirmReserve(input: $input) {
      reservationNumber
      displayReservationNumber
      description
      status {
        CRS
        PMS
      }
      wallet
      paymentDate
      providerName
      totalDiscount
      additionalDiscount
      promotionDiscount
      subtotalBeforeDiscount
      subtotalAfterDiscount
      totalPayable
      roomStaysReserveDetails {
        CRSNumber
        transactionNumber
        totalPriceBeforeDiscount
      }
    }
  }
`
